import React from 'react';

const BonusRounds = () => (
  <div className='container-fluid text-center text-white ask-rounds-bg'>
    <div className='row py-2'>
      <div className='col'>
        <h2 className='ask-nav text-white py-3'>THREE OF THESE BONUS ROUNDS</h2>
      </div>
    </div>

    <div className='row mt-2'>
      <div className='col'>
        <h3 className='ask-alphabois'><strong>alphabois</strong></h3>
      </div>
    </div>
    <div className='row mb-2'>
      <div className='col'>
        <h5 className='ask-text'>All of these answers start with the same letter.</h5>
      </div>
    </div>

    <div className='row'>
      <div className='col'>
        <h3 className='ask-choosybois'>choosybois</h3>
      </div>
    </div>
    <div className='row mb-2'>
      <div className='col'>
        <h5 className='ask-text'>Multiple choice questions with some kind of twist.</h5>
      </div>
    </div>

    <div className='row'>
      <div className='col'>
        <h3 className='ask-blankibois'><strong>Bl_nkibois</strong></h3>
      </div>
    </div>
    <div className='row mb-2'>
      <div className='col'>
        <h5 className='ask-text'>You get some of the letters. You provide the rest.</h5>
      </div>
    </div>

    <div className='row'>
      <div className='col'>
        <h3 className='ask-lookybois'>LOOKYBOIS</h3>
      </div>
    </div>
    <div className='row mb-2'>
      <div className='col'>
        <h5 className='ask-text'>Identify these flags, people, animals, etc.</h5>
      </div>
    </div>

    <div className='row'>
      <div className='col'>
        <h3 className='ask-buildybois'>Buildybois</h3>
      </div>
    </div>
    <div className='row mb-2'>
      <div className='col'>
        <h5 className='ask-text'>Which 5 of these options are components of the category?</h5>
      </div>
    </div>

    <div className='row'>
      <div className='col'>
        <h3 className='ask-orderbois'>Orderbois</h3>
      </div>
    </div>
    <div className='row mb-2'>
      <div className='col'>
        <h5 className='ask-text'>Not finding the pattern and completing the sequence would be chaos.</h5>
      </div>
    </div>

    <div className='row'>
      <div className='col'>
        <h3 className='ask-torturebois'>torturebois</h3>
      </div>
    </div>
    <div className='row mb-2'>
      <div className='col'>
        <h5 className='ask-text'>One question. Lots of info. Enjoy.</h5>
      </div>
    </div>

    <div className='row'>
      <div className='col'>
        <h3 className='ask-auditobois'>-Auditobois-</h3>
      </div>
    </div>
    <div className='row pb-4'>
      <div className='col'>
        <h5 className='ask-text'>What is it that you're listening to?</h5>
      </div>
    </div>

    <div className='row'>
      <div className='col'>
        <h3 className='ask-sleuthybois'>Sleuthybois</h3>
      </div>
    </div>
    <div className='row pb-4'>
      <div className='col'>
        <h5 className='ask-text'>The fewer hints you need, the more points you get.</h5>
      </div>
    </div>

    <div className='row'>
      <div className='col'>
        <h3 className='ask-chronobois'>chronobois</h3>
      </div>
    </div>
    <div className='row pb-4'>
      <div className='col'>
        <h5 className='ask-text'>Can you make a timeline in time?</h5>
      </div>
    </div>
  </div>
);

export default BonusRounds;
